import { render, staticRenderFns } from "./ConfettiBag.vue?vue&type=template&id=5927ea15"
import script from "./ConfettiBag.vue?vue&type=script&lang=ts"
export * from "./ConfettiBag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports